export default {
    common: {
        terms: "Privacy Policy and Terms of Service",
    },
};
